import React from 'react';
import classes from "./BookingConfirmation.module.css"
import { useBooking } from "../../../store/bookingStore";
import { useNavigate } from 'react-router-dom';
import { parseLocalDateString } from '../../../util/parseLocalDate';
import { buildCoarseLocationText } from '../../../util/locationPrivacy';

const BookingConfirmation = ({ data }) => {
    const { bookingData, clearBookingData } = useBooking();
    const navigate = useNavigate();

    const resetBookingState = () => {
        clearBookingData();
    };

    const navigateToBooking = () => {
        const bookingId = bookingData.id;
        resetBookingState();
        navigate(`/bookings/details/${bookingId}`);
    }

    const handleStudioClick = () => {
        resetBookingState();
        navigate(`/studio/${data?.id}`);
    };

    const formatDate = (date) => {
        const parsed = parseLocalDateString(date);
        if (!parsed) return '';
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return parsed.toLocaleDateString('de-DE', options);
    };

return (
    <div className={classes.bookingConfirmation}>
        <div className={classes.bookingConfirmationContent}>
            <div className={classes.headerContainer}>
                <div className={classes.headerInsideContainer}>
                    <div className={classes.bookingConfirmationIcon}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="24" viewBox="0 0 32 24" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M31.6132 2.59646L9.6969 23.4423L9.69648 23.4419L9.69441 23.4439L0.398438 13.948L2.49103 11.8994L9.76814 19.3331L29.595 0.474609L31.6132 2.59646Z" fill="white"/>
                        </svg>
                    </div>
                    <h1 className={`${classes.bookingConfirmationTitle} titleSemibold2`}>Deine Buchung wurde angefragt!</h1>
                </div>
                <p className={`${classes.bookingConfirmationText} slimRegularSmallText`}>
                    {data?.User?.firstName} {data?.User?.lastName} hat 24 Stunden um deine Anfrage zu bestätigen. 
                    Wir schicken dir eine Buchungsbestätigung per E-Mail.
                </p>
                <p className={`${classes.bookingConfirmationTextPhone} slimRegularSmallText`}>
                    {data?.User?.firstName} {data?.User?.lastName} hat 24 Stunden um deine
                </p>
                <p className={`${classes.bookingConfirmationTextPhone} slimRegularSmallText`}>
                    Anfrage zu bestätigen. Wir schicken dir
                </p>
                <p className={`${classes.bookingConfirmationTextPhone} slimRegularSmallText`}>
                    eine Buchungsbestätigung per E-Mail.
                </p>
            </div>
            <div className={classes.bookingConfirmationStudioContainer}>
                <div className={classes.bookedStudioContainer}>
                    <div className={classes.bookedStudioImageContainer}>
                        <img src={data?.processedImages[0]} alt="studio" />
                    </div>
                    <div className={classes.bookedStudioTextContainer}>
                        <h2 className={`${classes.bookedStudioTitle} semiboldLarge`}>{data?.StudioName}</h2>
                        <p className={`${classes.bookedStudioText} slimRegularMiddleText`}>
                            {buildCoarseLocationText(data)}
                        </p>
                        {data?.rating && (
                            <div className={classes.ratingContainer}>
                                <p className={`${classes.ratingText} slimRegularSmallText`}>{data?.rating}</p>
                                <div className={classes.ratingStarsContainer}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="8" viewBox="0 0 9 8" fill="none">
                                    <g clipPath="url(#clip0_7595_2481)">
                                    <path d="M6.27827 6.10615L6.59908 7.98641L4.17969 6.72102L6.14015 5.30859L6.23372 5.84772L6.27827 6.10615Z" fill="#1D1E1B"/>
                                    <path d="M2.12807 5.84745L2.22163 5.30832L0.265625 3.41469L2.97017 3.0226L4.1821 0.589844L5.39402 3.0226L8.09857 3.41469L1.76271 7.98614L2.12807 5.84745Z" fill="#1D1E1B"/>
                                    </g>
                                    <defs>
                                    <clipPath id="clip0_7595_2481">
                                    <rect width="7.83294" height="7.39629" fill="white" transform="translate(0.265625 0.589844)"/>
                                    </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <span className={`${classes.numberOfRatings} slimRegularSmallText`}>
                                (25)
                                </span>
                            </div>
                        )}
                        <h3 className={`${classes.bookingDateAndTime} semiboldSmall`}>
                            Datum und Zeit
                        </h3>
                        <p className={`${classes.bookingDateAndTimeText} slimRegularMiddleText`}>
                            {formatDate(bookingData?.date)}
                        </p>
                        <p className={`${classes.bookingDateAndTimeText} slimRegularMiddleText`}>
                            {bookingData?.startTime} - {bookingData?.endTime}
                        </p>
                    </div>
                </div>
                <div className={classes.buttonsContainer}>
                    <button className={`${classes.button} mediumLarge`} onClick={handleStudioClick}>
                        Zum Studio
                    </button>
                    <button className={`${classes.button} mediumLarge`} onClick={() => {navigateToBooking();}}>
                        Buchung anschauen
                    </button>
                </div>
            </div>
            <div className={classes.horizontalLine}></div>
            <div className={classes.extrasPhoneContainer}>
                <h3 className={`${classes.bookingDateAndTimePhone} semiboldSmall`}>
                    Datum und Zeit
                </h3>
                <p className={`${classes.bookingDateAndTimeTextPhone} slimRegularMiddleText`}>
                    {formatDate(bookingData?.date)}
                </p>
                <p className={`${classes.bookingDateAndTimeTextPhone} slimRegularMiddleText`}>
                    {bookingData?.startTime} - {bookingData?.endTime} Uhr
                </p>
            </div>
            <div className={classes.buttonsContainerPhone}>
                <button className={`${classes.button} mediumLarge`} onClick={handleStudioClick}>
                    Zum Studio
                </button>
                <button className={`${classes.button} mediumLarge`} onClick={() => {navigateToBooking();}}>
                    Buchung anschauen
                </button>
            </div>
        </div>
        <div className={classes.bookingFinish}>
            <button onClick={handleStudioClick} className={classes.closeButton}>Fertig</button>
        </div>
    </div>
  );
};

export default BookingConfirmation;
